"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _Icon2 = require("../../../Icon");
var _Icon3 = _interopRequireDefault(_Icon2);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
var IconPlaneTripInternational = /*#__PURE__*/
function (_Icon) {
  _inherits(IconPlaneTripInternational, _Icon);
  function IconPlaneTripInternational(props) {
    var _this;
    _classCallCheck(this, IconPlaneTripInternational);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(IconPlaneTripInternational).call(this, props));
    _this.name = 'IconPlaneTripInternational';
    _this.icon = _react2.default.createElement("svg", {
      viewBox: "0 0 24 24",
      width: "1em",
      height: "1em",
      focusable: "false",
      "aria-hidden": "true",
      role: "presentation"
    }, _react2.default.createElement("g", {
      className: "plane-trip-international_svg__group0"
    }, _react2.default.createElement("path", {
      className: "plane-trip-international_svg__path0",
      d: "M15.138 23.721a1.002 1.002 0 01-.933-1.362l1.041-2.703-3.24 1.281a.996.996 0 01-.908-.089L7.44 18.487a1.004 1.004 0 01-.423-1.101.995.995 0 01.467-.606l1.073-.617a1.004 1.004 0 01.906-.046l2.23.998 2.861-1.142-2.2-1.463a1 1 0 01.095-1.722l1.026-.53a1.003 1.003 0 01.997.043l3.609 2.263 3.442-1.374a1.783 1.783 0 012.32.955 1.78 1.78 0 01-.952 2.327l-3.288 1.453-2.619 4.78a1.003 1.003 0 01-.419.405l-.965.499c-.139.072-.3.112-.462.112zm.984-5.449a.501.501 0 01.467.68l-1.451 3.768.97-.501 2.699-4.924a.497.497 0 01.236-.217l3.452-1.525a.778.778 0 10-.594-1.438l-10.035 4.007a.488.488 0 01-.389-.007l-2.424-1.084-1.073.617 3.657 2.361 4.299-1.7a.479.479 0 01.186-.037zm-3.214-4.597l2.774 1.846 1.249-.499-2.992-1.877-.003-.251v.25h.001l-1.029.531z"
    }), _react2.default.createElement("path", {
      className: "plane-trip-international_svg__path1",
      d: "M6.539 16.127a.52.52 0 01-.096-.009 7.947 7.947 0 01-5.081-3.423C.182 10.914-.234 8.779.192 6.685s1.641-3.897 3.422-5.077A7.95 7.95 0 019.624.437a8.025 8.025 0 016.407 7.838.5.5 0 01-1 0 6.936 6.936 0 00-1.267-4h-2.452a.5.5 0 00-.485.379l-.5 2a.497.497 0 00.057.378.495.495 0 00.428.243h1.053c.246 0 .453.176.493.418l.527 3.165a.5.5 0 11-.986.165l-.458-2.747h-.629a1.49 1.49 0 01-1.286-.728 1.498 1.498 0 01-.168-1.136l.5-2a1.499 1.499 0 011.455-1.137h1.604a7.022 7.022 0 00-3.492-1.858 6.952 6.952 0 00-5.258 1.024 6.97 6.97 0 00-2.842 3.834h2.927c.69 0 1.288.468 1.455 1.137l.5 2a1.494 1.494 0 01-.394 1.424c-.283.284-.66.44-1.061.44h-.31l-.532 2.663c.813.593 1.73.996 2.729 1.199a.5.5 0 01.39.59.502.502 0 01-.49.399zM1.106 7.275a6.958 6.958 0 001.09 4.867c.248.374.531.724.844 1.043l.502-2.509a.5.5 0 01.49-.402h.72a.498.498 0 00.484-.622l-.5-2a.498.498 0 00-.484-.377H1.106z"
    })));
    return _this;
  }
  return IconPlaneTripInternational;
}(_Icon3.default);
exports.default = IconPlaneTripInternational;